import { ITrackEventAction } from '../types/analytics';
import { createAction } from 'redux-act';

export const trackEventAction = createAction<ITrackEventAction>();
